<div
    class="footer-container"
    [ngClass]="{ 'tournament-footer': tournamentFooter }">
    <div class="footer-section">
        <div class="sb-footer_row">
            <div class="footer-links">
                <div
                    class="common-header"
                    (click)="showContent('links')">
                    <h3>{{ 'footer.useful_links_title' | transloco }}</h3>
                    <img
                        src="assets/images/svg/arrow-down.svg"
                        class="arrow-img"
                        [class.rotated]="isRotated['links']" />
                </div>
                @if (content['links'] && screenWidth <= 824 && !tournamentFooter) {
                    <ul class="links-content">
                        <li class="links-item">
                            <a
                                [routerLink]="['/terms-and-conditions']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.terms_and_conditions' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/account-verification']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.account_verifications' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/responsible-gaming']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.responsible_gaming' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/support']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.kyc_policy' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/complaint']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.complaint_submission' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/deposits_withdrawals']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.deposits_withdrawals' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/security']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.security' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/privacy-policy']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.policy_privacy' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                href="https://betimpact.tawk.help/es"
                                target="_blank">
                                {{ 'footer.need_help' | transloco }}
                            </a>
                        </li>
                    </ul>
                } @else if (screenWidth > 824 || tournamentFooter) {
                    <ul class="links-content">
                        <li class="links-item">
                            <a
                                [routerLink]="['/terms-and-conditions']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.terms_and_conditions' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/account-verification']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.account_verifications' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/responsible-gaming']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.responsible_gaming' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/support']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.kyc_policy' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/complaint']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.complaint_submission' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/deposits_withdrawals']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.deposits_withdrawals' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/security']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.security' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                [routerLink]="['/privacy-policy']"
                                routerLinkActive="router-link-active">
                                {{ 'footer.policy_privacy' | transloco }}
                            </a>
                        </li>
                        <li class="links-item">
                            <a
                                href="https://betimpact.tawk.help/es"
                                target="_blank">
                                {{ 'footer.need_help' | transloco }}
                            </a>
                        </li>
                    </ul>
                }
            </div>
            <div class="about-us">
                <div
                    class="common-header"
                    (click)="showContent('about')">
                    <h3>
                        {{ 'footer.about_us_title' | transloco }}
                    </h3>
                    <img
                        src="assets/images/svg/arrow-down.svg"
                        class="arrow-img"
                        [class.rotated]="isRotated['about']" />
                </div>
                @if (content['about'] && screenWidth <= 824 && !tournamentFooter) {
                    <div class="about-content">
                        <li>
                            <p class="about-text">
                                {{ 'footer.about_us_subtitle' | transloco }}
                            </p>
                        </li>
                    </div>
                } @else if (screenWidth > 824 || tournamentFooter) {
                    <div class="about-content">
                        <li>
                            <p class="about-text">
                                {{ 'footer.about_us_subtitle' | transloco }}
                            </p>
                        </li>
                    </div>
                }
            </div>

            <div class="payment-methods">
                <div class="common-header">
                    <h3>
                        {{ 'footer.play_method' | transloco }}
                    </h3>
                </div>

                <ul class="payment-content">
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-50"
                            src="/assets/footer-img/visa.svg"
                            alt="visa" />
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-50"
                            src="/assets/footer-img/mastercard.svg"
                            alt="mastercard" />
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-60"
                            src="/assets/payment/oxxo.png"
                            alt="oxxo" />
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-60"
                            src="/assets/payment/spei.svg"
                            alt="spei" />
                    </li>
                    <li class="payment-item-list">
                        @if (darkMode) {
                            <img
                                width="50px"
                                height="30px"
                                class="payment-item-list-img logo-60"
                                src="/assets/footer-img/codi-white.png"
                                alt="codi" />
                        } @else {
                            <img
                                width="50px"
                                height="30px"
                                class="payment-item-list-img logo-60"
                                src="/assets/footer-img/codi-black.png"
                                alt="codi" />
                        }
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-85"
                            src="/assets/payment/todito.png"
                            alt="todito" />
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-75"
                            src="/assets/payment/crypto.png"
                            alt="crypto" />
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div class="sb-footer_row"> -->
        <!-- <div class="payment-methods">
                <div class="common-header">
                    <h3>
                        {{ 'footer.play_method' | transloco }}
                    </h3>
                </div>

                <ul class="payment-content">
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-50"
                            src="/assets/footer-img/visa.svg"
                            alt="visa" />
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-50"
                            src="/assets/footer-img/mastercard.svg"
                            alt="mastercard" />
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-60"
                            src="/assets/payment/oxxo.png"
                            alt="oxxo" />
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-60"
                            src="/assets/payment/spei.svg"
                            alt="spei" />
                    </li>
                    <li class="payment-item-list">
                        @if (darkMode) {
                            <img
                                width="50px"
                                height="30px"
                                class="payment-item-list-img logo-60"
                                src="/assets/footer-img/codi-white.png"
                                alt="codi" />
                        } @else {
                            <img
                                width="50px"
                                height="30px"
                                class="payment-item-list-img logo-60"
                                src="/assets/footer-img/codi-black.png"
                                alt="codi" />
                        }
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-85"
                            src="/assets/payment/todito.png"
                            alt="todito" />
                    </li>
                    <li class="payment-item-list">
                        <img
                            width="50px"
                            height="30px"
                            class="payment-item-list-img logo-75"
                            src="/assets/payment/crypto.png"
                            alt="crypto" />
                    </li>
                </ul>
            </div> -->
        <!-- <div class="footer-apps">
                <div class="common-header">
                    <h3>
                        {{ 'footer.mobile_app_title' | transloco }}
                    </h3>
                </div>

                <p class="apps-text">
                    {{ 'footer.mobile_app_subtitle' | transloco }}
                </p>
                <div class="images row">
                    <img
                        src="assets/images/footer/android-store.png"
                        class="android-store"
                        alt="" />
                    <img
                        src="assets/images/footer/app-store.png"
                        class="app-store"
                        alt="" />
                </div>
            </div> -->
        <!-- </div> -->

        <div class="footer-validation">
            <a
                href="/assets/verification.html"
                class="footer-logo">
                <img
                    width="65px"
                    height="65px"
                    src="/assets/images/validation.png"
                    alt="f-logo" />
            </a>
            <a
                [routerLink]="['/sport/soccer']"
                class="validation-text">
                {{ 'footer.sports_games_1' | transloco }}
            </a>
            <a
                [routerLink]="['/live']"
                class="validation-text">
                {{ 'footer.sports_games_2' | transloco }}
            </a>
            <a
                [routerLink]="['/casino']"
                class="validation-text">
                {{ 'footer.sports_games_3' | transloco }}
            </a>
            <a
                [routerLink]="['/live-casino']"
                class="validation-text">
                {{ 'footer.sports_games_4' | transloco }}
            </a>
        </div>

        <div class="footer-notes">
            <ul class="note-socials">
                <li class="social-item">
                    <a
                        href="https://www.facebook.com/betimpact1/"
                        target="_blank">
                        <img
                            src="/assets/images/footer/facebook.svg"
                            width="40px"
                            alt="Facebook Betimpact" />
                    </a>
                </li>
                <li class="social-item">
                    <a
                        href="https://www.instagram.com/betimpact_/"
                        target="_blank">
                        <img
                            src="/assets/images/footer/instagram.svg"
                            width="40px"
                            alt="Instagram Betimpact" />
                    </a>
                </li>
                <li class="social-item">
                    <a
                        href="https://x.com/betimpact_"
                        target="_blank">
                        <img
                            src="/assets/images/footer/twitter.svg"
                            width="40px"
                            alt="Twitter Betimpact" />
                    </a>
                </li>
                <li class="social-item">
                    <a
                        href="https://linkedin.com/company/betimpact/"
                        target="_blank">
                        <img
                            src="/assets/images/footer/linkedin.svg"
                            width="40px"
                            alt="Linkedin Betimpact" />
                    </a>
                </li>
                <li
                    class="social-item"
                    target="_blank">
                    <a href="https://www.youtube.com/">
                        <img
                            src="/assets/images/footer/youtube.svg"
                            width="40px"
                            alt="Youtube Betimpact" />
                    </a>
                </li>
            </ul>
            <div class="notes-text">
                {{ 'footer.play_responsibly' | transloco }}
            </div>
        </div>
    </div>
</div>
